import { render, staticRenderFns } from "./DownloadSurveys.vue?vue&type=template&id=f95ee3fc&"
import script from "./DownloadSurveys.vue?vue&type=script&lang=js&"
export * from "./DownloadSurveys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports